import {makeService} from './api';

const service = makeService('offers');

export default service;
